module.exports = __webpack_public_path__ + "img/live.a2f5d0a5.png";